import { shellStringResources } from '../../Resources/ShellStringResources';
import { sanitizeAndFormatString } from '../../shared/utils/string.util';
import { IModel, Collection, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { ParameterValue } from '../base/parameter-value';
import { Pipeline } from '../pipeline/pipeline';

@Metamodel.model({
    name: 'trigger pipeline'
})
export class TriggerPipeline extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: Pipeline.MODEL,
        reference: true,
        constraint: {
            required: false
        }
    })
    public pipeline: Pipeline;

    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false,
            validator: TriggerPipeline.prototype.validateTriggerParameterValueSet
        }
    })
    public parameters: ParameterValue[] = [];

    private validateTriggerParameterValueSet(_triggerPipeline?: TriggerPipeline, parameterValues?: ParameterValue[]): IViolation[] | undefined {
        const violations: IViolation[] = [];
        if (parameterValues) {
            const upToDateParameterValues: ParameterValue[] = [];

            parameterValues.forEach((paramValue) => {
                if (paramValue && paramValue.parameter && paramValue.parameter.owner) {
                    // only keep non orphaned parameters, this is a result of parameters being deleted from the original pipeline
                    // we should remove these from the trigger
                    upToDateParameterValues.push(paramValue);
                }
            });

            parameterValues.length = 0;
            upToDateParameterValues.forEach((param) => parameterValues.push(param));
            parameterValues.forEach((param) => param.parameter && this.validateParameterValue(violations, param, param.value));
        }

        return violations.length <= 0 ? undefined : violations;
    }

    private validateParameterValue(violations: IViolation[], parameterValue: ParameterValue, value: string): void {
        if (parameterValue && !(parameterValue.parameter.defaultValue || value)) {
            violations.push({
                message: () => sanitizeAndFormatString(shellStringResources.Trigger_ParameterValueRequired, parameterValue.parameter.name)
            });
        } else if (parameterValue && value) {
            const parameterType = parameterValue.parameter._type ? parameterValue.parameter._type.toLowerCase() : '';
            switch (parameterType) {
                case 'int':
                    if (!Number.isInteger(Number(value))) {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Trigger_Parameterization_ValidIntegerErrorMessage, parameterValue.parameter.name)
                        });
                    }

                    break;
                case 'float':
                    if (isNaN(Number(value))) {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Trigger_Parameterization_ValidFloatErrorMessage, parameterValue.parameter.name)
                        });
                    }

                    break;
                case 'bool':
                    if (String(value) !== 'true' && String(value) !== 'false') {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Trigger_Parameterization_ValidBooleanErrorMessage, parameterValue.parameter.name)
                        });
                    }

                    break;
                case 'array':
                    try {
                        const defaultArray = JSON.parse(String(value));

                        if (!Array.isArray(defaultArray)) {
                            violations.push({
                                message: () => sanitizeAndFormatString(shellStringResources.Trigger_Parameterization_ValidArrayErrorMessage, parameterValue.parameter.name)
                            });
                        }
                    } catch (error) {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Trigger_Parameterization_ValidArrayErrorMessage, parameterValue.parameter.name)
                        });
                    }

                    break;
                default:
                    break;
            }
        }
    }
}
